import { render } from "./Utenti.vue?vue&type=template&id=75415c88&scoped=true"
import script from "./Utenti.vue?vue&type=script&lang=js"
export * from "./Utenti.vue?vue&type=script&lang=js"

import "./Utenti.vue?vue&type=style&index=0&id=75415c88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75415c88"]])

export default __exports__